import { render, staticRenderFns } from "./ChildLayout.vue?vue&type=template&id=3ca344ca"
import script from "./ChildLayout.vue?vue&type=script&lang=ts"
export * from "./ChildLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports